import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import facilityService from '../../../services/apiServices/facilityService';
import { documentationActions, PhysicianActions } from 'src/redux/actions/constant';
import physicianService from 'src/services/apiServices/physician-service/physician-service';
// import physicianService from 'src/services/apiServices/physician-service/physician-service';
const {
  SUCCESS_CHECK_PHYSICIAN,
  REQUEST_CHECK_PHYSICIAN,
  FAILURE_CHECK_PHYSICIAN,
  RESET_CHECK_PHYSICIAN,
  LOADING_CHECK_PHYSICIAN,
} = documentationActions;

const { REQUEST_GET_ALL_PHYSICIAN_DOCUMENTS, REQUEST_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS } =
  PhysicianActions;

function* checkPhysicianSignature(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_CHECK_PHYSICIAN });
    const response = yield call(physicianService.checkPhysicianSign, action.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_CHECK_PHYSICIAN, payload: response });

      yield put({
        type: REQUEST_GET_ALL_PHYSICIAN_DOCUMENTS,
        physicianId: action?.payload?.physicianId,
        physicianDto: {
          patientIds: [],
          facilityIds: [],
          startDateOfService: null,
          endDateOfService: null,
          startDueDate: null,
          endDueDate: null,
          sortBy: 'dateOfService',
          sortDirection: 'desc',
          signatureStatus: 'PENDING',
          page: 0,
          status: null,
          pageSize: 20,
          type: [],
        },
      });

      yield put({
        type: REQUEST_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS,
        physicianId: action?.payload?.physicianId,
        physicianDto: {
          patientIds: [],
          facilityIds: [],
          startDateOfService: null,
          endDateOfService: null,
          startDueDate: null,
          endDueDate: null,
          sortBy: 'dateOfService',
          sortDirection: 'desc',
          signatureStatus: 'COMPLETED',
          page: 0,
          status: null,
          pageSize: 20,
          type: [],
        },
      });
    } else {
      throw { ...response.data, statusCode: response?.status };
    }
  } catch (error) {
    yield put({ type: FAILURE_CHECK_PHYSICIAN, payload: error });
  }
}

function* checkPhysicianSignatureSaga() {
  yield takeEvery(REQUEST_CHECK_PHYSICIAN, checkPhysicianSignature);
}

export default checkPhysicianSignatureSaga;
